import Grid from "@mui/material/Grid";
import MDBox from "../../MDBox";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import OPERATIONS from "./operations.js";
import MDInput from "../../MDInput";

function Configurator({ params, onChange }) {
  const [tab, setTab] = useState(0);
  const tables = params.tables || [];

  useEffect(() => {
    if (!params.nbQuestions && params.nbQuestions !== 0) {
      onChange({ ...params, nbQuestions: 10 });
    }
  }, [!params.nbQuestions && params.nbQuestions !== 0]);

  const handleToggleTable = (operation) =>
    onChange({
      ...params,
      tables: tables.includes(operation)
        ? tables.filter((o) => o !== operation)
        : tables.concat([operation]),
    });

  const allChecked =
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].findIndex(
      (x) => !tables.includes(OPERATIONS[tab].sign + "" + x)
    ) < 0;

  const handleToggleAll = useCallback(
    () =>
      onChange({
        ...params,
        tables: tables
          .filter((o) => !o.startsWith(OPERATIONS[tab].sign))
          .concat(
            allChecked
              ? []
              : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((x) => OPERATIONS[tab].sign + "" + x)
          ),
      }),
    [allChecked, tables, tab, params]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Tabs value={tab} onChange={(event, newValue) => setTab(newValue)}>
          {OPERATIONS.map((operation) => (
            <Tab
              key={operation.sign}
              label={operation.title}
              icon={<MDBox sx={{ mr: 1, marginBottom: "0px !important" }}>{operation.sign}</MDBox>}
            />
          ))}
        </Tabs>
      </Grid>
      <Grid item xs={12}>
        <MDBox display="flex" alignItems="center" flexWrap="wrap">
          <MDBox
            sx={{
              border: "1px solid silver",
              padding: 0.5,
              borderRadius: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              transition: "background-color 200ms ease-in-out",
              minWidth: 40,
              maxWidth: 60,
              minHeight: 40,
              margin: 0.5,
              cursor: "pointer",
              backgroundColor: allChecked ? "#ffffaa" : undefined,
              "&:hover": {
                backgroundColor: allChecked ? "#ffffaa" : "#f8f9fa",
              },
            }}
            onClick={handleToggleAll}
          >
            <DoneAllIcon />
          </MDBox>
          {(tab === 3 ? [] : [0]).concat([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]).map((x) => (
            <MDBox
              key={"" + OPERATIONS[tab].sign + x}
              sx={{
                border: "1px solid silver",
                padding: 0.5,
                borderRadius: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                transition: "background-color 200ms ease-in-out",
                minWidth: 40,
                maxWidth: 60,
                minHeight: 40,
                margin: 0.5,
                cursor: "pointer",
                backgroundColor: tables.includes(OPERATIONS[tab].sign + "" + x)
                  ? "#ffffaa"
                  : undefined,
                "&:hover": {
                  backgroundColor: tables.includes(OPERATIONS[tab].sign + "" + x)
                    ? "#ffffaa"
                    : "#f8f9fa",
                },
              }}
              onClick={() => handleToggleTable(OPERATIONS[tab].sign + "" + x)}
            >
              {OPERATIONS[tab].sign}
              {x}
            </MDBox>
          ))}
        </MDBox>
      </Grid>
      <Grid item xs={6}>
        <MDBox>
          <MDInput
            type="number"
            label="Nombre de questions"
            name="nbQuestions"
            InputProps={{
              inputProps: {
                min: 0,
                max: 50,
              },
            }}
            value={params.nbQuestions || 0}
            onChange={(e) => onChange({ ...params, nbQuestions: parseInt(e.target.value, 10) })}
            fullWidth
          />
        </MDBox>
      </Grid>
    </Grid>
  );
}
Configurator.propTypes = {
  params: PropTypes.object,
  onChange: PropTypes.func,
};

export default Configurator;
